<template>
  <div class="middle cadfm-flexitem-stretched">

    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <!--<action-button  @click="newUser" icon="new" bold :text="lang.button_NewUser"
            :title="lang.button_Newuser" :disabled="newuserButtonStatus"/>-->
            <div></div>



        </b-navbar-nav>
      </action-bar>
      <action-content>
        <Content   :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
  import ActionBar from '@/components/shared/ActionBar'
  import ActionButton from '@/components/shared/ActionButton'
  import ActionContent from '@/components/shared/ActionContent'
  import ActionPanel from '@/components/shared/ActionPanel'


  import Content from "@/components/Settings/Views/Main/Middle/Content/Content"

//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'Middle',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content

  },
  props:{
    lang: Object
  },

  data () {
    return {


      newuserButtonStatus: false,


    }
  },
  computed:{


  },
  created() {
    console.log("Middle main Settings")

  },

  methods: {

    

  }
}
</script>


<style scoped>

  .middle{
    border-right: 1px solid #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/Settings/Views/Main/Middle/Middle.vue